import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import MaintainerChargePointListScreen from './screens/MaintainerChargePointListScreen';
import MaintainerChargePointDetailScreen from './screens/MaintainerChargePointDetailScreen';

function MaintainerChargePoint(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route path="" element={<MaintainerChargePointListScreen />} />
                    <Route path=":chargePointId" element={<MaintainerChargePointDetailScreen />} />
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default MaintainerChargePoint;
